import { EventEmitter, Injectable } from "@angular/core";
import { HttpHeaders, HttpClient } from "@angular/common/http";
import {
  apiLoginURL,
  apiURL,
  apiInsightURL,
  isTokenValid,
  downloadExcelURL,
  downloadNewExcelURL,
  downloadConsoleReportUrl,
  apiURLAruhat,
} from "src/app/common";
import { retry } from "rxjs/operators";
import * as FileSaver from "file-saver";
import { Observable } from "rxjs";
import { Subscription } from "rxjs";

@Injectable()
export class RestService {
  uploadGSTPDFRestService: EventEmitter<any> = new EventEmitter();
  customHttpDefaultOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
    }),
  };
  loadEstablishmentApi: Subscription | undefined;

  constructor(private httpClient: HttpClient) {}

  postRestAPICall(body: any, data: any) {
    this.httpClient
      .post(apiInsightURL, body, this.customHttpDefaultOptions)
      .pipe(retry(1))
      .subscribe(
        (response) => {
          data(response);
        },
        (error) => data(this.handleError(error))
      );
  }

  postRestLoginCall(body: any, data: any) {
    this.httpClient
      .post(apiLoginURL, body, this.customHttpDefaultOptions)
      .subscribe(
        (response) => {
          data(response);
        },
        (error) => data(this.handleError(error))
      );
  }

  postRestCall(body: any, requestURL: any, data: any, headers: any) {
    this.httpClient.post(apiURL + requestURL, body, headers).subscribe(
      (response) => {
        data(response);
      },
      (error) => data(this.handleError(error))
    );
  }

  postRestCallClient(body: any, requestURL: any, data: any, headers: any) {
    this.httpClient.post(requestURL, body, headers).subscribe(
      (response) => {
        data(response);
      },
      (error) => {
        // debugger
        let url = error['url'];
        if(url != null)
        {
          if(url != '')
          {
            if(url.includes("createDigitalPdfOrder/create"))
            {
              if(error['statusText'] == "Unknown Error")
              {
                this.uploadGSTPDFRestService.next(true);
              }
            }
          }
        }
        data(this.handleError(error));
      }
    );
  }

  getRest(requestURL: string): Observable<any> {
    return this.httpClient.get(requestURL);
  }

  getRestCall(requestURL: any, data: any, headers: any) {
    this.httpClient.get(apiURL + requestURL, headers).subscribe(
      (response) => {
        data(response);
      },
      (error) => data(this.handleError(error))
    );
  }

  getRestCallClient(requestURL: any, requestBody: any, data: any) {
    return this.httpClient.get(apiURL + requestURL, requestBody).subscribe(
      (response) => {
        data(response);
      },
      (error) => data(this.handleError(error))
    );
  }

  private handleError(error: any) {
    let description = "There was an error: " + error.status;
    return {
      status: error.status,
      //message: error.message,
      errordescription: description,
    };
  }

  isTokenValid(body: any, data: any) {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    this.httpClient
      .post(isTokenValid, body, this.customHttpDefaultOptions)
      .pipe(retry(1))
      .subscribe(
        (response) => {
          data(response);
        },
        (error) => data(this.handleError(error))
      );
  }

  downloadExcelReport(body: any, data: any) {
    var t0 = performance.now();
    downloadExcelURL;
    this.postRestCallBlob(downloadExcelURL, body, (response: any) => {
      this.processResponse(response, (res: any) => {
        data(res);
      });
      var t1 = performance.now();
    });
  }

  //new function for excel functionality for otp and login
  downloadExcelReportNew(body: any, data: any) {
    var t0 = performance.now();
    downloadNewExcelURL;
    this.postRestCallBlob(downloadNewExcelURL, body, (response: any) => {
      this.processResponse(response, (res: any) => {
        data(res);
      });
      var t1 = performance.now();
    });
  }

  downloadConsoleReport(body: any, data: any) {
    var t0 = performance.now();
    downloadConsoleReportUrl;
    this.postRestCallBlob(downloadConsoleReportUrl, body, (response: any) => {
      this.processResponse(response, (res: any) => {
        data(res);
      });
      var t1 = performance.now();
    });
  }

  postRestCallBlob(documentDownloadURL1: any, body: any, data: any) {
    this.httpClient
      .post(documentDownloadURL1, body, {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
        }),
        observe: "response",
        responseType: "blob",
      })
      .pipe(retry(1))
      .subscribe(
        (value) => {
          data(value);
        },
        (error) => data(this.handleError(error))
      );
  }

  processResponse(value: any, res: any) {
    if (value.headers != undefined || value.headers != null) {
      const contentDispositionHeader: string = value.headers.get(
        "Content-Disposition"
      );
      var statusHeader: string = value.headers.get("custom-status");
      var messageHeader: string = value.headers.get("custom-message");
      const typeHeader: string = value.headers.get("custom-file-type");

      var data = { status: "", message: "" };
      data["status"] = statusHeader;
      data["message"] = messageHeader;
      if (statusHeader === "1") {
        const parts: string[] = contentDispositionHeader.split(";");
        const filename = parts[1].split("=")[1];
        const blob = new Blob([value.body], {
          type: "application/" + typeHeader,
        });
        FileSaver.saveAs(blob, filename);
      }
      res(data);
    } else {
      var data = { status: "", message: "" };
      data["status"] = value.status;
      data["message"] = value.errordescription;
      res(data);
    }
  }

  getLoadViewConfig(requestBody: any,header) {
    return this.httpClient.post(apiURLAruhat, requestBody,header);
  }
}
